import { Box, CircularProgress, Paper } from '@mui/material';
import React, { useEffect, useState } from 'react';
import DataList from '../../sharedcomponents/dataList/dataList';
import APIURLConstants from '../../config/config';
import ApiHelper from '../../utility/ApiHelper';
import { makeStyles } from '@mui/styles';
import Helper from '../../utility/helper';
import { excelFileType } from '../../constants/Constant';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import ConfirmationDialog from '../../sharedcomponents/confirmationdialog/confirmationDialog';

const useStyles = makeStyles(() => ({
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
}));

const BulkUser = () => {
    const classes = useStyles();
    const [bulkUserListData, setBulkUserListData] = useState([]);
    const [loading, setLoading] = useState(false);
    const userInfo = Helper.getStorage('userInfo');
     const [uploadUserLoader, setUploadUserLoader] = React.useState(false);
    const [snackBarProps, setSnackBarProps] = useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const [confirmation, setConfirmation] = useState({
        open: false,
        title: '',
        message: '',
        userID:'',
        isUpdated:0
    });
    const [disableRowButton, setDisableRowButton] = useState(false);

    
    useEffect(() => {
        getParticipantList(true)
    }, [])



    const getParticipantList = (loader) => {
        setLoading(loader)
        ApiHelper.get(
            APIURLConstants.GET_BULK_USER()
        )
            .then(async (res) => {
                if (res.data) {
                    setLoading(false)
                    if (res.data.length > 0) {
                        let usersData = [];
                        let rowData = res.data;
                        rowData.map((item) => {
                            usersData.push({
                                actualData: item,
                                row: [
                                    {
                                        label: 'Name',
                                        key: 'name',
                                        name: item.lastName + ' ' + item.firstName,
                                        width: '0.2',
                                        inColumn: true,
                                        toBulkUserName: item.bulkLastName + ' ' + item.bulkFirstName,
                                        showBulkUserName: true,
                                    },
                                    {
                                        label: 'Email',
                                        key: 'email',
                                        email: item.email,
                                        width: '0.2',
                                        inColumn: true,
                                        toBulkUserName: item.bulkEmail,
                                        showBulkUserName: true,
                                    },
                                    {
                                        label: 'Contact No',
                                        key: 'contactNo',
                                        contactNo: item.contactNo,
                                        width: '0.2',
                                        inColumn: true, 
                                        toBulkUserName: item.bulkContactNo,
                                        showBulkUserName: true,
                                    }, 
                                    {
                                        label: 'Action',
                                        key: 'BulkUser',
                                        BulkUser: 'BulkUser',
                                        width: '0.35',
                                        alignRight:true
                                    },
                                ],
                            });
                        });
                        setBulkUserListData(usersData)
                    }else{
                        setBulkUserListData([])
                    }
                    
                }
            }).catch((err) => {
                setLoading(false)
                console.log("err", err);
            }
            )
    }
    const updateRowData = (data) => {
        setDisableRowButton(true)
        const requestData = {
            userID: data.userID,
            isUpdated: data.isUpdated,
            createdBy: userInfo.userID
        }
        ApiHelper.post(APIURLConstants.UPDATE_BULK_USER, requestData)
            .then((res) => {
                if (res.data) {
                    getParticipantList(false)
                    setDisableRowButton(false)
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request updated successfully',
                    });
                    setConfirmation({
                        ...confirmation,
                        open: false,
                        userID:'',
                        isUpdated:0
                    });
                }

            }).catch((err) => {
                console.log(err);
                setDisableRowButton(false)
                setConfirmation({
                    ...confirmation,
                    open: false,
                    userID:'',
                    isUpdated:0
                });
            })
    }
    const handleExisting = (item) => {
        console.log(item);
        setConfirmation({
            open: true,
            title: '',
            OkButtonText: 'Ok',
            message: "Are you sure you want to update existing?",
            userID:item.actualData.userID,
            isUpdated: 1,
        });
        
    }
    const handleOverride = (item) => {
        setConfirmation({
            open: true,
            title: '',
            OkButtonText: 'Ok',
            message: "Are you sure you want to Override?",
            userID:item.actualData.userID,
            isUpdated: 2,
        });
        
    }
    const handleCreateNew = (item) => {
        setConfirmation({
            open: true,
            title: '',
            OkButtonText: 'Ok',
            message: "Are you sure you want to Creare New User?",
            userID:item.actualData.userID,
            isUpdated: 3,
        });         
    }
    function importBulkUser(obj) {
        return ApiHelper.post(APIURLConstants.BULK_USER_EXCEL_IMPORT, obj)
            .then((result) => {
                return result.data;
            })
            .catch((err) => {
                console.log(err);
            });
    }
    const handleMassUpdateImportUser = (attachmentDocument) => {
        if (attachmentDocument && attachmentDocument.target.files[0]) {
            let uploadFile = attachmentDocument.target.files[0];
            if (excelFileType.includes(uploadFile.type)) {
                let form = new FormData();                
                form.append('attachedFile', uploadFile);               
                form.append('createdBy', userInfo.userID);
                setUploadUserLoader(true)
                importBulkUser(
                    form
                )
                    .then((response) => {
                        let result = response;
                        setUploadUserLoader(false)
                        if (result.status > 0) {
                            setSnackBarProps({
                                openSnack: true,
                                variant: 'success',
                                message: result.message,
                            });
                            getParticipantList(true);
                        } else {
                            setSnackBarProps({
                                openSnack: true,
                                variant: 'error',
                                message: result.message,
                            });
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        setUploadUserLoader(false)
                        setSnackBarProps({
                            openSnack: true,
                            variant: 'error',
                            message: 'User import failed.',
                        });
                    });
            } else {
                setSnackBarProps({
                    openSnack: true,
                    variant: 'error',
                    message:
                        'Invalid file format, Please upload valid excel file.',
                });
            }
        } else {
            setSnackBarProps({
                openSnack: true,
                variant: 'error',
                message: 'Please select a file to upload.',
            });
        }
        attachmentDocument.target.value = null;
    };
    const updateBulkUserExcelReport = () => {
        ApiHelper.post(
            APIURLConstants.GET_BULK_USER_EXCEL_EXPORT, {
            EventID: 0,
            ModuleID: 0
        }).then((res) => {
            const finalObject = JSON.parse(res.data.value);
            if (finalObject) {
                if (finalObject.length > 0) {
                    let header = {};
                    Object.keys(finalObject[0]).forEach((key) => {
                        header[key] = key;
                    });
    
                    // Create an array with only the header object
                    const headerOnlyArray = [header];
                    
                    // Call the helper to download the report with headers only
                    Helper.downloadReport(
                        headerOnlyArray,
                        `Bulk_Upload-User-Report`
                    );
                }
            }
        });
    };
    return (
        <>
            <Box sx={{ width: '100%' }}>
                {loading ? (
                    <Box
                        sx={
                            loading
                                ? { paddingTop: '20%', paddingBottom: '20%' }
                                : ''
                        }
                        className={classes.loader}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <Paper sx={{ width: '100%', mb: 2, boxShadow: 'none', maxHeight: 'calc(100vh - 70px)', padding: 2 }}>
                        {bulkUserListData && (
                            <DataList
                                data={bulkUserListData}
                                showSearch={true}
                                searchLabel={'Search'}
                                moduleDisplayName={'Bulk Users'}
                                moduleToShow={true}
                                modPermission={'FULL'}
                                hideAdd={true}
                                hideDelete={true}
                                hideEdit={true}
                                handleExisting={handleExisting}
                                handleOverride={handleOverride}
                                handleCreateNew={handleCreateNew}
                                importFileType={excelFileType}
                                showUploadMassUpdateUser={true}
                                handleMassUpdateImportUser={handleMassUpdateImportUser}
                                updateTemplate={updateBulkUserExcelReport}
                                showUpdateTemplate={true}
                                showToolBarButton={true}
                                showSync={true}
                                getResults={() => getParticipantList(true)}
                                disableRowButton={disableRowButton}
                            />)}

                    </Paper>
                )}
                {
                <ConfirmationDialog
                    open={confirmation.open}
                    message={confirmation.message}
                    OkButtonText={confirmation.OkButtonText}
                    handleCnfClick={() =>
                        updateRowData(confirmation)
                    }
                    onCancelClick={() => {
                        setConfirmation({
                            ...confirmation,
                            open: false,
                            userID:'',
                            isUpdated:0
                        });
                    }}></ConfirmationDialog>
            }
                {snackBarProps.openSnack && (
                    <CustomizedSnackbars
                        {...snackBarProps}
                        onClose={() =>
                            setSnackBarProps({ ...snackBarProps, openSnack: false })
                        }></CustomizedSnackbars>
                )}
            </Box>
        </>
    )

}

export default BulkUser;